import React from "react";

const ErrorPage = (props) => (
  <div
    style={{
      top: "70px",
      padding: "80px",
      textAlign: "center",
    }}
  >
    <img alt="Error Loading" height="50" src={props.img} />
    <h4>{props.title}</h4>
    <p className="text-black-50">{props.description}</p>
    <div>{props.options} <small>{props.intent}</small></div>
  </div>
);

export default ErrorPage;
